/**
 * PRD Generation Constants
 *
 * Configuration values for PRD generation feature.
 */

/**
 * Minimum PRD content length (in characters) to consider a PRD as existing.
 * PRDs shorter than this are considered incomplete or placeholder content.
 */
export const MIN_EXISTING_PRD_LENGTH = 50;

/**
 * Completeness score threshold for finalization warning.
 * Users will see a confirmation dialog if they try to finalize a PRD
 * with a completeness score below this threshold.
 */
export const COMPLETENESS_WARNING_THRESHOLD = 85;

/**
 * Recommended minimum completeness score for best results.
 * Used in user-facing messages and recommendations.
 */
export const RECOMMENDED_COMPLETENESS_SCORE = 85;

/**
 * Maximum length (in characters) for long-form user-provided content:
 * project details and PRD content.
 *
 * Single source of truth for the web app. Mirrors the Python backend constant
 * `compounds_shared.limits.MAX_SPEC_CONTENT_CHARS` (apps/api, apps/mcp,
 * apps/agents) — the two MUST be kept in sync. There is no cross-language
 * import, so changes here must also be made in `compounds_shared/limits.py`.
 */
export const MAX_SPEC_CONTENT_LENGTH = 70000;
